"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TabItem = _interopRequireDefault(require("./TabItem"));

var _VerticalSeparator = _interopRequireDefault(require("../Separator/VerticalSeparator"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TYPE = {
  TABS: 'tabs',
  VIEW_SWITCHERS: 'view_switchers'
};
/**
 * Tabs component.
 * Note that Tabs is wrapped inside FlexLayout component which means that
 * any properties in FlexLayout can be added to customize styling.
 */

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    var activeKey = props.activeKey,
        defaultActiveKey = props.defaultActiveKey;
    _this.state = {
      activeKey: activeKey || defaultActiveKey,
      controlled: !!activeKey
    };
    return _this;
  }
  /**
   * @override
   * @param {object} props - next Props
   * @param {object} state - previous state
   * @return {object|null} new state object or null
   */


  _createClass(Tabs, [{
    key: "renderTabItems",
    value: function renderTabItems() {
      var _this2 = this;

      var _this$props = this.props,
          type = _this$props.type,
          data = _this$props.data;
      var tabItems = [];
      data.forEach(function (tab, index) {
        var key = tab.key,
            title = tab.title,
            disabled = tab.disabled,
            separator = tab.separator,
            itemProps = _objectWithoutProperties(tab, ["key", "title", "disabled", "separator"]);

        if (separator) {
          if (type === TYPE.TABS) {
            tabItems.push(_react.default.createElement(_VerticalSeparator.default, {
              key: "vertical".concat(index)
            }));
          }

          return;
        }

        var appearance = _TabItem.default.APPEARANCE.DISABLED;

        if (!disabled) {
          appearance = _this2.state.activeKey === key ? _TabItem.default.APPEARANCE.ACTIVE : _TabItem.default.APPEARANCE.NORMAL;
        }

        var tabItemProps = {
          title: title,
          key: key,
          appearance: appearance,
          type: type
        };
        /* eslint-disable react/jsx-no-bind */

        tabItems.push(_react.default.createElement(_TabItem.default, _extends({}, tabItemProps, itemProps, {
          onClick: _this2.handleOnTabClick.bind(_this2, key, index, tab)
        })));
        /* eslint-enable */
      });
      return tabItems;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          type = _this$props2.type,
          activeKey = _this$props2.activeKey,
          defaultActiveKey = _this$props2.defaultActiveKey,
          onTabClick = _this$props2.onTabClick,
          data = _this$props2.data,
          props = _objectWithoutProperties(_this$props2, ["className", "type", "activeKey", "defaultActiveKey", "onTabClick", "data"]);

      var tabItems = this.renderTabItems();
      var styleProps = {
        'data-type': type,
        // Flex properties
        padding: type === TYPE.TABS ? '0px-20px' : undefined,
        display: type === TYPE.VIEW_SWITCHERS ? 'inline-flex' : undefined
      };
      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-tabs")),
        itemSpacing: "30px",
        alignItems: "center"
      }, styleProps, props), tabItems);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.controlled) {
        var activeKey = props.activeKey;
        return _objectSpread({}, state, {
          activeKey: activeKey
        });
      }

      return null;
    }
    /**
     * Handle the click of the tab.
     * @param {string|number} key: the data.key that was clicked on.
     * @param {number} index: the index of the data array for the given tab
     * @param {object} tab: the tab item in the data.
     * @param {ReactEvent} event - React event.
     */

  }]);

  return Tabs;
}(_react.default.Component);

exports.default = Tabs;
Tabs.TYPE = TYPE;
Tabs.defaultProps = {
  data: [],
  type: TYPE.TABS
};
Tabs.propTypes = {
  /**
   * By default the styling is for Tabs.  If you need to
   * use View Switcher please see `<ViewSwitcher>` component
   * instead of using the type property here.
   *
   * @ignore
   */
  type: _propTypes.default.oneOf([TYPE.TABS, TYPE.VIEW_SWITCHERS]),

  /**
   * Array of tabs data to be used to display
   * the each tab title on the tabs bar.
   */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * This is a unique identifier for the given tab.
     */
    key: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

    /**
     * Title of the tab item.  If this is a string the component
     * will handle the styling properly for the various types and
     * appearances.  For other node type it is up to the application
     * to style it appropriately.
     */
    title: _propTypes.default.node,

    /**
     * A suffix display next to the title.
     * This is often used to display informational icons
     * with tooltip message.
     */
    titleSuffix: _propTypes.default.node,

    /**
     * To show that the tab is disabled.
     */
    disabled: _propTypes.default.bool,

    /**
     * When this is set to true and type="tabs" this is treated a
     * a group separator
     * All other properties in data will be ignored.
     */
    separator: _propTypes.default.bool
  })),

  /**
   * Identify which tab.key should be active.
   * Use this instead of activeKey if your app don't need
   * to take control of switch of the tab.
   */
  defaultActiveKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Identify which tab.key should be active.
   * Use this instead of defaultActiveKey if your app need to control
   * the timing of tab switching.
   * Note: if this is used you must provide onTabClick also.
   */
  activeKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Callback function to handle when a tab is clicked.
   * Note: this is required if the application is using activeKey
   * onTabClick(key, index, tab, event)
   * @param {string|number} key: This is the tab.key that received the click event.
   * @param {number} index: This is the index to the original props.data.
   * @param {object} tab: This is the tab item object.
   * @param {ReactEvent} event: The react event element.
   */
  onTabClick: _propTypes.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnTabClick = function (key, index, tab, event) {
    var _this3$state = _this3.state,
        activeKey = _this3$state.activeKey,
        controlled = _this3$state.controlled;
    var onTabClick = _this3.props.onTabClick;

    if (key === activeKey || tab.disabled) {
      return;
    }

    if (!controlled) {
      _this3.setState({
        activeKey: key
      });
    }

    if (onTabClick) {
      onTabClick(key, index, tab, event);
    }
  };
};